import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import useStyles from './icon-button-with-tooltip.styles';

const IconButtonWithTooltip = ({
  tooltip,
  icon,
  alt,
  onClick,
  iconClassName,
  imgClassName,
  tooltipClassName,
  placement = 'top'
}) => {
  const classes = useStyles();
  return (
    <Tooltip title={tooltip} placement={placement} classes={{ tooltip: tooltipClassName ?? classes.tooltip }}>
      <IconButton onClick={onClick} className={iconClassName}>
        <img
          className={imgClassName ? imgClassName : iconClassName ? iconClassName : classes.icon}
          src={icon}
          alt={alt || tooltip}
        />
      </IconButton>
    </Tooltip>
  );
};

IconButtonWithTooltip.propTypes = {
  tooltip: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  iconClassName: PropTypes.string,
  tooltipClassName: PropTypes.string
};

IconButtonWithTooltip.defaultProps = {
  alt: ''
};

export default IconButtonWithTooltip;
